import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1474FF', light: '#3B8BFF', dark: '#0F5FE0', contrastText: '#fff' },
    secondary: { main: '#1D3557', contrastText: '#fff' },
    background: { default: '#EEF5FB', paper: '#ffffff' },
    text: { primary: '#07111F', secondary: '#1D3557' },
    divider: 'rgba(20,116,255,0.12)',
    error: { main: '#ef4444' },
    warning: { main: '#f59e0b' },
    success: { main: '#059669' },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontSize: '2rem', fontWeight: 800, letterSpacing: '-0.04em' },
    h2: { fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.03em' },
    h3: { fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.02em' },
    h4: { fontSize: '1rem', fontWeight: 700 },
    body1: { fontSize: '0.9375rem', lineHeight: 1.65 },
    body2: { fontSize: '0.8125rem', lineHeight: 1.55, color: '#1D3557' },
    caption: { fontSize: '0.6875rem', color: '#6B6899', letterSpacing: '0.01em' },
  },
  shape: { borderRadius: 10 },
  shadows: [
    'none',
    '0 1px 3px rgba(20,116,255,0.06)',
    '0 2px 8px rgba(20,116,255,0.08)',
    '0 4px 20px rgba(20,116,255,0.10)',
    '0 8px 32px rgba(20,116,255,0.14)',
    ...Array(20).fill('none'),
  ] as any,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          fontSize: '0.875rem',
          letterSpacing: '-0.01em',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #1474FF 0%, #3B8BFF 100%)',
          boxShadow: '0 2px 8px rgba(20,116,255,0.25)',
          '&:hover': {
            background: 'linear-gradient(135deg, #0F5FE0 0%, #1474FF 100%)',
            boxShadow: '0 4px 16px rgba(20,116,255,0.35)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(20,116,255,0.10)',
          boxShadow: '0 2px 12px rgba(20,116,255,0.08)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            fontSize: '0.9rem',
            '& fieldset': { borderColor: 'rgba(20,116,255,0.20)' },
            '&:hover fieldset': { borderColor: 'rgba(20,116,255,0.35)' },
            '&.Mui-focused fieldset': { borderColor: '#1474FF', borderWidth: '1.5px' },
          },
        },
      },
    },
  },
});

export default theme;
